var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StudentCategoriesForm',{attrs:{"student-category":_vm.category,"is-loading":_vm.isLoading},on:{"on-submit":_vm.onStudentCategoryUpdate,"on-abort":_vm.onStudentCategoryAbortUpdate}})}
var staticRenderFns = []

export { render, staticRenderFns }